import { render } from "./ProfitTrendChart.vue?vue&type=template&id=345bebd8"
import script from "./ProfitTrendChart.vue?vue&type=script&lang=js"
export * from "./ProfitTrendChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__